import * as client from './client';

export const ADS_STANDARD_PLAN = 'x_ads_standard';
export const ADS_PROSPECTING_PLAN = 'x_ads_prospecting';

export function switchAccount(accountId) {
  if (accountId === 'new-team') {
    client.navigateToNewTeams();
    return;
  }

  client.switchAccount(accountId).then(() => {
    window.location = '/';
  });
}
